import { WidgetRegistry } from "@smallstack/widget-core";
import { VisitorEventsWidget } from "./lib/visitor-events-widget";

export function addInfoScreenWidgets(widgetRegistry: WidgetRegistry): void {
  widgetRegistry.addWidget(VisitorEventsWidget);
}
